import React from "react";
import "./Navbar.css";
import { truck } from "../../assets/imagesPath";
import { Link } from "react-router-dom";
import PATHS from "../../routes/Paths";

const TopNavbar = () => {
  return (
    <div className="topNavbar">
      <p className="wlcmText">
        Welcome to <span className="brandName">Easy QIST</span>
      </p>

      <div className="marquee">
        <div className="marquee-content">
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
          <span className="wlcmText">
            <b>Currently the service is available only in Lahore</b>
          </span>
        </div>
      </div>

      <Link to={PATHS.orderHistory} className="nav-link" data-toggle="tab">
        <img src={truck} alt="Track Order" />
        Track order and history
      </Link>
    </div>
  );
};

export default TopNavbar;
